/**
 * @file Xoe tools API — list the tool calls available for a conversation's expert.
 * @module api/xoe/XoeToolsApi
 */

import { XoeTool } from '../../types/xoe/XoeTypes';
import {ENV} from "../../config/runtimeEnv";
import { http } from "../../lib/http/client";

export interface ListToolsParams {
	uuid: string;
}

/**
 * List the catalogue tools available for the conversation's resolved expert.
 * Each tool carries action_type, label, kind, description and an editable starter_template.
 */
export const listXoeTools = async (params: ListToolsParams): Promise<XoeTool[]> => {
	const { uuid } = params;
	const response = await http.get(
		`${ENV.VITE_XOE_AGENT_SERVER}/practitioner/xoe/conversations/${uuid}/tools`,
	);
	// Backend wraps the list: { data: [...] }
	return response.data.data;
};
